module.exports = __webpack_public_path__ + "static/media/Jeff.939e7f57.jpg";